import { inject, injectable } from "inversify";
import { AppDeployer } from "../AppDeployer";
import { ConsoleUI } from "../../utils/ConsoleUI";
import { KotennaApi } from "../../lib/kotenna/KotennaApi";
import TYPES from "../../TYPES";
import { CloudProvider } from "../../lib/kotenna/CloudProvider";
import { DigitalOceanApi } from "../../lib/DigitalOcean";
import { DigitalOceanCloudProvider } from "../../providers/DigitalOceanWorker";
const opn = require('opn');

@injectable()
export class DoWordpress implements  AppDeployer {


    private console: ConsoleUI;
    private  api: KotennaApi;

    constructor( @inject(TYPES.ConsoleUI) ui: ConsoleUI, @inject(TYPES.KotennaApi) api: KotennaApi ) {
        this.console = ui;
        this.api = api;
    }

    async run(): Promise<any> {

        const digitalocean = new DigitalOceanApi();

        // 1) Choose a provider. A DigitalOcean provider
        const provider = await this.getProvider();
        digitalocean.setProvider(<DigitalOceanCloudProvider> provider);     // Let's throw away the whole idea of Typescript with a single line

        // 2) Pick a name, we will force the .porkettaeu suffix
        let siteName: string = await this.console.promptInput("Claim your site (we will append the suffix .demo.hakuna.io)");
        siteName = siteName.trim();
        if (siteName.endsWith(".")) {
            siteName = siteName.slice(0, -1);
        }
        siteName = `${siteName}.demo.hakuna.io`;

        const confirm = await this.console.promptConfirm(`Your site name will be ${siteName}. Confirm?`);

        // TODO check for site availability

        if(!confirm) {
            return Promise.reject("");
        }

        // 2bis) ask some questions
        const wpAdminPass = await this.console.promptInput("Choose your Wordpress admin password (username will be 'admin')");
        const dbPassword = wpAdminPass;

        // 3) Upload an ssh key
        this.console.loaderStart("Cooking a wordpress site");
        const sshKeyId = await digitalocean.uploadRandomKey();
        const instance_name = `test-hakuna-wp-${siteName}`;

        // Funziona
        const user_data = `#cloud-config
            rancher:
            write_files:
              - path: /etc/rc.local
                permissions: "0755"
                owner: root
                content: |
                  #!/bin/bash
                  wait-for-docker
                  docker run --name mysql -e MYSQL_ROOT_PASSWORD=${dbPassword} -e SITE=${siteName} -e WPPASS=${wpAdminPass} -d --restart=unless-stopped porketta/test-wp-db                  
                  docker run  --link mysql:mysql -e WORDPRESS_DB_NAME=wp-porketta -d --restart=unless-stopped -p 80:80 wordpress
                  `;

        // Now, create the DNS and the droplet async
        const template = {
            name: instance_name,
            region: ['fra1', 'lon1', 'sfo2'][0],
            size: ['s-4vcpu-8gb', 's-2vcpu-4gb'][0],
            image: 43507861, //rancheros
            ssh_keys: [sshKeyId],
            backups: false,
            ipv6: false,
            private_networking: false,
            monitoring: false,
            volumes: [],
            tags: ['porketta', 'test', 'noproduction', 'wordpress'],
            user_data
        };



        const [record, droplet] = await Promise.all([
            this.api.recordCreate(siteName)
            .catch(err => {
                console.log("redcordCreateError"); 
                console.log(err); 
                throw err;
            }),
            digitalocean.createDroplet(template).catch( err => {
                console.log("createDroplet"); 

                console.log(err);
                throw err;
            })
        ]);

        this.console.loaderSuccess("Your droplet is in the hoven");
        this.console.log(`Remeber to create  VHost to manage your droplet with porketta!`);
        return Promise.resolve(`http://${siteName}`);
    }

    public async getProvider(): Promise<CloudProvider> {

        this.console.loaderStart("Loading available providers");

        let providers = await this.api.providers();
        providers = providers.filter(provider => provider.api === "digitalocean");
        if(providers.length === 0) {
            this.console.loaderFail("Can't find any DigitalOcean CloudProvider");
            this.console.log("Create a provider ");
            return Promise.reject("No DigitalOcean CloudProvider found");
        }

        this.console.loaderSuccess("Providers loaded");

        const providerName = await this.console.promptList("Choose which provider to use", providers);
        const provider = providers.find(p => p.name === providerName);

        return Promise.resolve(provider!);

    }

}